<template>
    <div >
        <div class="width100 paddingbottom20">
            <div class="shadow width100 marginbottom10">
                <div class="width100 floatleft2">
                  <div class="padding15">
                    <div class="darkblue bold font16">Kies je betaalmethode: </div>
                  </div>
                    <div class="padding15">
                        <div v-for="(method, key) in paymentMethods">
                          <div  class="width100 marginbottom20" style="display: flex; line-height: 40px;">
                            <input
                                type="radio"
                                name="method"
                                v-bind:id="'betaalmethode_' + method.id"
                                class="floatleft2 marginright10"
                                v-bind:value="method.id"
                                :checked="key === 0"
                            />
                            <label v-bind:for="'betaalmethode_' + method.id" style="display: flex">
                              <img v-bind:src="method.image.size1x"  style="height:24px;margin-top:8px;">
                              <span style="margin-left:10px;">{{ method.description }}{{ method.transactionCosts && method.transactionCosts > 0 ? ' (+' + method.transactionCosts + '% transactiekosten) ' : '' }}</span>
                              <div
                                  v-if="method.issuers && method.issuers.length > 0"
                                  class="floatleft2"
                                  style="vertical-align:center;width:200px;margin-left:10px;"
                              >
                                <div class="select-drop">
                                  <select
                                      id="ideal_bank"
                                      v-bind:name="'bank[' + method.id + ']'"
                                      class="selectlist"
                                  >
                                    <option
                                        v-for="(issuer) in method.issuers"

                                        :value="issuer.id"
                                    >
                                      {{ issuer.name }}
                                    </option>

                                  </select>
                                </div>
                              </div>
                            </label>
                          </div>
                          <div class="clear"></div>
                        </div>








                        <div
                            class="width100 rood tcenter"
                            v-show="checkboxWarn && (!checkboxAccept || (!checkboxAccept3) || (!checkboxAccept5))"
                        >

                            Je dient akkoord te gaan met de algemene
                            voorwaarden & de geldende reisprotocollen, anders mogen wij deze aanvraag helaas
                            niet verwerken...<br />
                        </div>
                        <div class="clear"></div>

                      <div class="width100 paddingbottom10 notification-cabin" style="box-sizing: border-box;cursor:pointer;">
                            <label>
                                <input
                                    id="betalen_checkbox"
                                    type="checkbox"
                                    v-model="checkboxAccept"
                                />
                                Hierbij bevestig ik de boeking en ga ik akkoord
                                met de
                                <a
                                    href="/paginas/artikel/artikel.php?alias=algemene-voorwaarden"
                                    target="_blank"
                                >
                                    Algemene Voorwaarden</a
                                >, het
                                <a
                                    href="/paginas/artikel/artikel.php?alias=privacy"
                                    target="_blank"
                                >
                                    Privacy Beleid
                                </a> en
                              bevestig ik alle gegevens correct ingevoerd te hebben volgens paspoort.
                              Het is niet mogelijk om kosteloos gegevens te wijzigen of te annuleren na het voldoen van de betaling.
                              <span v-if="nrf"> U staat op het punt een reservering te maken o.b.v. een speciaal tarief (100% Non-Refundable).
                                Let wel: de standaard annuleringsvoorwaarden zijn van toepassing. Bij annulering door uzelf is de gehele reissom verschuldigd (100% niet-restitueerbaar) en dient u het verschil te voldoen.</span>
                            </label>
                        </div>

                      <div class="width100 paddingbottom10 notification-cabin" style="box-sizing: border-box; margin: 0 !important;cursor:pointer;margin-bottom:10px !important">
                        <label>
                          <input
                              id="corona_checkbox2"
                              type="checkbox"
                              v-model="checkboxAccept3"
                          />

                          <b>Ja</b>, ik begrijp dat ik bij het voldoen van de (aan)betaling een bindende/definitieve reisovereenkomst aan ga.
                          Ik bevestig dat ik de cruise, eventuele andere reisonderdelen, vertrekdatum en promotie heb gecontroleerd en hiermee akkoord gaat.

                        </label>
                      </div>

                      <div class="width100 paddingbottom10 notification-cabin" style="box-sizing: border-box;cursor:pointer; margin-top: 0 !important;">
                        <label>
                          <input
                              id="betalen_checkbox"
                              type="checkbox"
                              v-model="checkboxAccept5"
                          />
                          Ik bevestig dat iedereen in het gezelschap beschikt over een geldig woonadres
                          <div class="tooltip">(i)
                            <span class="tooltiptext" >
                              <ul class="active_list">
                                <li class="item">België</li>
                                <li class="item">Bulgarije</li>
                                <li class="item">Cyprus</li>
                                <li class="item">Denemarken</li>
                                <li class="item">Duitsland</li>
                                <li class="item">Estland</li>
                                <li class="item">Engelan</li>
                                <li class="item">Finland</li>
                                <li class="item">Frankrijk</li>
                                <li class="item">Griekenland</li>
                                <li class="item">Hongarije</li>
                                <li class="item">Ierland</li>
                                <li class="item">IJsland</li>
                                <li class="item">Italië</li>
                                <li class="item">Kroatië</li>
                                <li class="item">Letland</li>
                                <li class="item">Liechtenstein</li>
                                <li class="item">Litouwen</li>
                                <li class="item">Luxemburg</li>
                                <li class="item">Malta</li>
                                <li class="item">Nederland</li>
                                <li class="item">Noorwegen</li>
                                <li class="item">Oostenrijk</li>
                                <li class="item">Polen</li>
                                <li class="item">Portugal</li>
                                <li class="item">Roemenië</li>
                                <li class="item">Slovenië</li>
                                <li class="item">Slowakije</li>
                                <li class="item">Spanje</li>
                                <li class="item">Tsjechië</li>
                                <li class="item">IJsland</li>
                                <li class="item">Zweden</li>
                                <li class="item">Zwitserland</li>
                              </ul>
                            </span>
                          </div>
                          en het niet mogelijk is kosteloos te annuleren wanneer dit niet het geval is.

                        </label>
                      </div>

                        <div class="clear"></div>

                        <button
                            type="button"
                            id="testBoekenBetalen"
                            class="btn btn-success btn-addon width100 font18 bold uppercase floatleft2 padding20"
                            v-on:click="validateInputs()"
                        >
                            Betalen
                            <font-awesome-icon
                                v-if="waiting"
                                icon="spinner"
                                :spin="true"
                            />
                        </button>

                        <div class="clear"></div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: 'PaymentInfo',
    data: function() {
        return {
            checkboxAccept: false,
          checkboxAccept5: false,

            checkboxAccept3: false,
            checkboxWarn: false,
          paymentMethods: Object,
        }
    },
    props: {
        payment: Object,
        cruise: Object,
        waiting: Boolean,

      nrf: Boolean,
    },
    methods: {
        validateInputs: function() {
            if (!this.checkboxAccept || !this.checkboxAccept3 || !this.checkboxAccept5) {
                this.checkboxWarn = true
            } else {
                this.$emit('createReservation-click')
            }
        },
      getPaymentMethods: function() {
          var data = this
        $.ajax({
          url: '/paginas/boeken2/ajax.php',
          method: 'POST',
          data: {
            action: 'getPaymentMethods'
          },
          success: function(responseData) {
             data.paymentMethods = responseData;
          },
          error: function(error) {
            console.log('Error loading payments');
          },
        })

      }
  },
  mounted: function() {
      this.getPaymentMethods()
  }
}
</script>

<style>
label {
  cursor:pointer;
}
.floatleft2 {
    float: left;
}

.idealsmall-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -289px -258px;
    display: block;
    width: 22px;
    height: 28px;
}

.paypalsmall-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -314px -258px;
    display: block;
    width: 60px;
    height: 28px;
}

.mrcashsmall-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -432px -259px;
    display: block;
    width: 34px;
    height: 32px;
}

.visasmall-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -376px -260px;
    display: block;
    width: 28px;
    height: 28px;
}

.mastersmall-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -404px -260px;
    display: block;
    width: 28px;
    height: 28px;
}

.amexsmall-img {
    background-image: url(https://cdn.cruisereizen.nl/img/template/cruisereizen_sprite.png);
    background-position: -506px -258px;
    display: block;
    width: 21px;
    height: 21px;
}
</style>
